<template>
  <router-link :to="to">
    <slot />
  </router-link>
</template>
<script>
import { TAGS_URL } from '@/modules/tag/tag.constants';

export default {
  name: 'DaraTagLink',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    to() {
      return {
        name: TAGS_URL.view.name,
        path: TAGS_URL.view.path,
        params: {
          id: this.id,
        },
      };
    },
  },
};
</script>
